import Button from '@/components/Button'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import { error404Bottom, error404Top, evaImage2, image404 } from '@/images'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import style from './styles/error.module.scss'

const Error404 = (): React.ReactElement => {
  const navigate = useNavigate()
  const page = usePage()

  const { config } = page?.init_state?.global

  const handleGoBack = (): void => navigate(-1)

  return (
    <div
      className={style.error}
      style={{
        backgroundImage: `url(${String(error404Bottom)})`
      }}
    >
      <Title type='h1' hidden>
        Ошибка 404
      </Title>

      <img
        src={image404}
        width='369px'
        height='149px'
        alt='Ошибка'
        className={style.error__mobimage}
      />

      <img
        src={error404Top}
        width='475px'
        height='778px'
        alt='Ошибка'
        className={style.error__topimage}
      />
      <div className={style.error_bottom}>
        <img
          src={evaImage2}
          width='475px'
          height='778px'
          alt='Ошибка'
          className={style.error__eva}
        />
        <div className={style.error_content}>
          <p className={style.error__title}>Ой! Данная страница не найдена!</p>
          <p className={style.error__text}>
            Вероятно данная страница устарела или была удалена, или был введен
            неверный адрес.
          </p>

          <div className={style.error_buttons}>
            <Button
              size='large'
              theme='secondary'
              highlight
              wide
              href={config.home_url}
              className={style.error__button}
            >
              Перейти на главную
            </Button>
            <Button
              size='large'
              highlight
              wide
              onClick={handleGoBack}
              className={style.error__button}
            >
              Вернуться назад
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error404
